import type { ReviewDetail } from './useReview'
interface MyPost extends ReviewDetail {
  confirmYn?: boolean;
  peacemaker: {
    reviewAgreed: boolean,
    activityDt?: string,
    activityMember?: number,
    activityPlaceGb?: number,
    activityPlaceNm?: string,
    activityPlaceTxt?: string,
    activityDurationNm?: string,
    activityDurationGb?: number,
    materialTypeGb?: number,
    materialTypeNm?: string,
    categoryId?: number,
    categoryName?: string,
  }
}
export default function () {
  const languageGbSn = useI18n().locale

  async function fetchMyPost(docId: number, withRelated: number = 1, maskName: number = 1) {
    const now = new Date()
    const likeDt = now.toISOString().substring(0, 10)

    return await useAPI<MyPost | null>(`/hml/v1/me/posts/${docId}`, {
      method: 'GET',
      query: { languageGbSn, withRelated, maskName, likeDt },
    })
  }

  async function fetchMyPostCommentToken(id: number) {
    return await useAPI<string>(`/hml/v1/me/posts/${id}/comment-token`, {
      method: 'GET',
      query: {
        languageGbSn: languageGbSn.value,
      },
    })
  }

  async function deleteMyPost(docId: number) {
    return await useAPI(`/hml/v1/me/posts/${docId}`, {
      method: 'DELETE',
    })
  }

  async function fetchMyPostCount() {
    return await useAPI('/hml/v1/me/posts/cnt', {
      method: 'GET',
    })
  }


  async function toggleMyPostLike(docId: number) {
    const { $api } = useNuxtApp()
    const likeDt = new Date().toISOString().substring(0, 10)
    return await $api(`/hml/v1/me/posts/${docId}/toggle-like`, {
      method: 'PUT',
      body: { likeDt },
    })
  }

  return {
    fetchMyPost,
    fetchMyPostCommentToken,
    deleteMyPost,
    fetchMyPostCount,
    toggleMyPostLike,
  }
}
